import HeroSlider from "@/sections/HeroSlider";
import MarqueeRibbon from "@/components/MarqueeRibbon";
import About from "@/sections/About";
import Services from "@/sections/Services";
import Journey from "@/sections/Journey";
import Hosting from "@/sections/Hosting";
import AllInOne from "@/sections/AllInOne";
import Marketing from "@/sections/Marketing";
import Portfolio from "@/sections/Portfolio";
import WhyUs from "@/sections/WhyUs";
import ContactSection from "@/sections/ContactSection";

export default function Home() {
  return (
    <main>
      <HeroSlider />
      <MarqueeRibbon />
      <About />
      <Services />
      <Journey />
      <Hosting />
      <AllInOne />
      <Marketing />
      <Portfolio />
      <WhyUs />
      <ContactSection />
    </main>
  );
}
